import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'pm-maintenance-modal',
  templateUrl: 'maintenance-modal.html',
  styleUrls: ['./maintenance-modal.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MaintenanceModal {
  @Input() message: string;
  @Input() support: string;

  constructor(private modalCtrl: ModalController) {}

  onContactSupport() {
    if (this.support && this.support.indexOf('support@penmateapp.com') > -1) {
      if (typeof window !== 'undefined') {
        window.location.href = 'mailto:support@penmateapp.com';
      }
    }
  }

  // Modal is intentionally non-dismissible via backdrop, but we expose dismiss() for cleanup.
  dismiss() {
    this.modalCtrl.dismiss();
  }
}
